// extracted by mini-css-extract-plugin
export default {"activities":"Activities_activities__WJ5qV","list":"Activities_list__FHSeo"};